import { render, staticRenderFns } from "./InspectUser.vue?vue&type=template&id=712c45a6&"
import script from "./InspectUser.vue?vue&type=script&lang=ts&"
export * from "./InspectUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports